import React from "react";
import {formatCurrency, formatDate} from "../../../../utils/helpers";

/** @import { FisaAccountDetailsBoxProps } from './FisaAccountClosureTypes' */

/**
 * FISA Account Details Box Component
 * @param {FisaAccountDetailsBoxProps} props
 */
export const FisaAccountDetailsBox = ({ fisaAccount }) => {
    return <div
        className="text__navy fisa-account-closure__info-box fisa-account-closure__info-box--wrap">
        <div className="fisa-account-closure__info-box__group fisa-account-closure__no-border">
            <div className="fisa-account-closure__info-box__data-wrapper fisa-account-closure__info-box__data-wrapper--wrap fisa-account-closure__no-border">
                <p>
                    <b>Your current {fisaAccount?.product.name}</b>
                </p>
            </div>
            <div className="fisa-account-closure__info-box__data-wrapper fisa-account-closure__info-box__data-wrapper--wrap fisa-account-closure__no-border">
                <p data-di-mask>
                    Account number: {fisaAccount?.accountNumber}
                </p>
            </div>
        </div>
        <div className="fisa-account-closure__info-box__group fisa-account-closure__no-border">
            <p className="fisa-account-closure__info-box__data-wrapper fisa-account-closure__info-box__data-wrapper--wrap fisa-account-closure__no-border" data-di-mask>Balance: {fisaAccount ? formatCurrency(fisaAccount.balance) : ''}</p>
            <p className="fisa-account-closure__info-box__data-wrapper fisa-account-closure__info-box__data-wrapper--wrap fisa-account-closure__no-border">
                <b>
                    {fisaAccount?.maturity?.maturityDate 
                        ? `Matures on ${formatDate(fisaAccount.maturity.maturityDate)}`
                        : fisaAccount?.coolingOffEndDate 
                            ? `Cancellation period ends on ${formatDate(fisaAccount.coolingOffEndDate)}`
                            : ''
                    }
                </b>
            </p>
        </div>
    </div>
}
